<template>
  <v-footer padless>
    <v-container>
      <v-row justify="center">
        <v-col sm="12" md="8" lg="6">
          <v-btn
            text
            class="body-2 font-weight-light"
            :to="{ name: 'privacystatement' }"
            >{{ this.$t("button.privacy_statement") }}</v-btn
          >
          <v-btn
            text
            class="body-2 font-weight-light"
            :to="{ name: 'termsandconditions' }"
            >{{ this.$t("button.terms_and_conditions") }}</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="$store.state.config.template_settings.footer_html">
        <span
          style="width: 100%"
          v-html="$store.state.config.template_settings.footer_html"
        ></span>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.theme--light.v-footer {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
}
</style>
